export default __webpack_public_path__ + "41d59d3b901272299d6235b122204587.png";